import HRManagerJobApproveOrReject from "@/components/dialog/HRManagerJobApproveOrReject";
import JobJustificationDetails from "@/components/JobJustificationDetails";
import InvoiceSkeleton from "@/components/skeleton/InvoiceSkeleton";
import { STALE_TIME_INVOICE } from "@/constants";
import { UserContext } from "@/context/User/UserContext";
import { getJobJustificationById } from "@/services/hiring-justification-functions";
import { useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

const HRManagerJobApproval = () => {
	const { id } = useParams<{ id: string }>() as { id: string };
	const user = useContext(UserContext);

	const job = useQuery({
		queryKey: ["job", id],
		queryFn: () => getJobJustificationById(user?.accessToken!, id),
		enabled: !!user?.accessToken,
		staleTime: STALE_TIME_INVOICE,
	});

	return (
		<div className="max-w-5xl mx-auto p-4 rounded-md bg-white border mt-4">
			{job.isLoading ? (
				<InvoiceSkeleton />
			) : job.isError ? (
				<div className="align-centre">
					<h5 className="text-center">Error loading job.</h5>
				</div>
			) : (
				job.data && (
					<>
						<div className="flex gap-3 items-end justify-between">
							<h1 className="font-medium text-4xl">Job: {job.data.job}</h1>
							<HRManagerJobApproveOrReject
								jobId={job.data.jobid}
								accessToken={user?.accessToken!}
							/>
						</div>
						<JobJustificationDetails job={job.data} />
					</>
				)
			)}
		</div>
	);
};

export default HRManagerJobApproval;
